let sanitizeHtml = require('sanitize-html-react')

const config = {
    allowedTags: ['br', 'span', 'div', 'sup', 'b', 'h1', 'h2', 'h3', 'a'],
    allowedAttributes: {
        'span': ['class', 'id'],
        'div': ['class'],
        'a': ['href', 'class', 'data-action-detail', 'target'],
        'br': ['class'],
        'h2': ['id']
    }
}

const allowedNothingConfig = {
    allowedTags: [],
    allowedAttributes: []
}

export const sanitize = (html, strict) => {
    const sanitizeConfig = strict ? allowedNothingConfig : config
    return sanitizeHtml(html, sanitizeConfig)
}
